<template>
    <v-app>
      <v-app-bar color="primary" app v-show="showLayout" >
        <template v-slot:prepend>
          <v-app-bar-nav-icon><v-icon icon="mdi-menu" @click.stop="drawer = !drawer" ></v-icon></v-app-bar-nav-icon>
        </template>
        <v-app-bar-title>Office</v-app-bar-title>
        <template v-slot:append>
          <v-select label="Organization" style="min-width: 200px;"
            density="compact" 
            hide-details
            v-model="organization"
            item-title="name"
            variant="solo"
            item-value="organizationId"
            :items="organizations"></v-select>
          <v-app-bar-nav-icon @click="logout"><v-icon icon="mdi-exit-to-app"></v-icon></v-app-bar-nav-icon>
        </template>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" v-if="!disableDrawer">
        <v-list>
          <v-list-item
            :prepend-avatar="imagePath"
            :subtitle="email"
            :title=fullName()
          ></v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list density="compact" nav v-if="role == 'Admin'">
          <v-list-item prepend-icon="mdi-view-dashboard" title="Dashboard" value="dahsboard" to="/home"></v-list-item>
          <v-list-item prepend-icon="mdi-account-multiple" title="Members" value="members" to="/members"></v-list-item>
          <v-list-item prepend-icon="mdi-chart-bar-stacked" title="Reports" value="reports" to="/reports"></v-list-item>
          <v-list-item prepend-icon="mdi-clipboard-text-multiple" title="Projects" value="projects" to="/projects"></v-list-item>
          <v-list-item prepend-icon="mdi-domain" title="Companies" value="companies" to="/companies"></v-list-item>
          <v-list-item prepend-icon="mdi-city" title="Locations" value="locations" to="/locations"></v-list-item>
          <v-list-item prepend-icon="mdi-bug-outline" title="Defects" value="defects" to="/defects"></v-list-item>
          <v-list-item prepend-icon="mdi-cog" title="Settings" value="settings" to="/settings"></v-list-item>
        </v-list>
        <v-list density="compact" nav v-if="role == 'User'">
          <v-list-item prepend-icon="mdi-view-dashboard" title="Dashboard" value="dahsboard" to="/home"></v-list-item>
          <v-list-item prepend-icon="mdi-chart-bar-stacked" title="Reports" value="reports" to="/reports"></v-list-item>
        </v-list>
        <template v-slot:append>
          <div class="pa-2">
            <v-switch label="Dark Mode" inset v-model="themeToggle" @update:model-value="(a) => switchTheme(a)"></v-switch>
          </div>
        </template>
      </v-navigation-drawer>
      <v-main>
        <RouterView></RouterView>
      </v-main>
    </v-app>
  
</template>

<script>
import Account from "./services/Account";
import MemberApi from "./services/MemberApi";
import { useStore } from './services/store'
import { jwtDecode } from "jwt-decode";

export default {
  name: 'App',
  data() {
    return {
      showLayout: true,
      drawer: true,
      disableDrawer: false,
      imagePath: '',
      firstName: '',
      lastName: '',
      email: '',
      organization: null,
      organizations: [],
      themeToggle: false,
      role: "User"
    }
  },
  mounted() {
    const store = useStore();
    this.changeRole()
    this.$router.isReady().then(() => {
        var crtPath = this.$router.currentRoute.value.path;

        if(store.theme) { 
          this.$vuetify.theme.global.name = store.theme;
          if(store.theme == 'myThemeDark') {
            this.themeToggle = true;
          }
        }

        if(this.$router.currentRoute.value.path == "/" || (this.$router.currentRoute.value.path + '').startsWith("/login")) {
          if(Account.isLoggedIn()) {
            this.$router.push('/home')
          }
          this.showLayout = false;
          this.disableDrawer = true;
        }
        else if((this.$router.currentRoute.value.path + '').startsWith("/delete-account")) {
          this.showLayout = false;
          this.disableDrawer = true;
          return
        }

        Account.tryToLoggin().then(() => {
          if(crtPath == "" || crtPath == "/") {
            this.$router.push('/home')
          }
          this.loadUserInfo();
          this.loadUserOrg();
        }).catch(() => {
          this.logout()
        })
    })
  },
  methods: {
    fullName() {
      return this.firstName + " " + this.lastName;
    },
    logout() {
      const store = useStore();
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      store.organization = 0;
      
      this.$router.push('/login')
    },
    loadUserInfo() {
      MemberApi.userInfo().then((response) => {
        if(response.data) {
          this.email = response.data.email;
          this.firstName = response.data.firstName;
          this.lastName = response.data.lastName;
          this.imagePath = response.data.image;
        }
      }).catch((ex) => {
        console.log(ex);
      })
    },
    loadUserOrg() {
      const store = useStore();
      MemberApi.getOrganizations().then((response) =>  {
        if(response.data && response.data.organizations && Array.isArray(response.data.organizations)) {
          
          store.organization = response.data.organizations[0].organizationId;
          this.organizations = response.data.organizations;
          this.organization = response.data.organizations[0];
        }
      }).catch((ex) => {
        console.log(ex);
      })
    },
    switchTheme(value) {
      
      const store = useStore();
      if(!value)
        store.theme = 'myTheme';
      else 
        store.theme = 'myThemeDark';
      
      this.$vuetify.theme.global.name = !value ? 'myTheme' : 'myThemeDark'
    },
    clearStorage(to, from) {
      if(to.path.startsWith('/reports') && !from.path.startsWith('/reports')) {
        const store = useStore();
        store.reportStartDate = ''
        store.reportEndDate = ''
        store.reportOrderBy = ''
        store.reportOffset = 0
        store.reportCount = 0
        store.projectPageCompany = null
        store.reportPageCompany = null
        store.reportPageMember = null
        store.reportPageProject = null
      }
    },
    changeRole() {
      const store = useStore();
      try {
        let accessToken = localStorage.getItem('access_token');
        if(!accessToken)
          return
        let claims = jwtDecode(accessToken);
        var jwtRole = claims['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
        
        if(jwtRole) {
          this.role = jwtRole
          store.role = jwtRole
        }
      } catch {
          this.role = 'User';
          store.role = this.role
      }
    }
  },
  watch: {
    $route(to, from) {
      const store = useStore();
      this.changeRole()
      this.clearStorage(to, from)
      if(to.path == "/" || (to.path + '').startsWith("/login")) {
        this.showLayout = false;
        this.disableDrawer = true; 
      }
      else if((this.$router.currentRoute.value.path + '').startsWith("/delete-account")) {
          this.showLayout = false;
          this.disableDrawer = true;
          return
      }
      else {
        this.showLayout = true;
        this.disableDrawer = false; 
        
        if(!store.organization) {
          this.loadUserInfo()
          this.loadUserOrg()
        }
      }
    }
  }
}
</script>

<style>

.free-text {
  font-size: 0.9rem;
}


a.default-link:link, a.default-link:visited {
  color: rgb(var(--v-theme-primary)); 
  text-decoration: none;
  font-weight: bold;
}

.click-tr {
  cursor: pointer;
}

.click-tr:hover {
  background: rgb(var(--v-theme-surface-light));
}
</style>